module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABMBAMAAABpMw88AAAAJFBMVEXGDDDkipv33eLTRGDGDDDmlaX////UR2LdboTwwMnlkaH//v7EoRQ3AAAABHRSTlPV6fjdIC0BwgAAAE9JREFUeAFjZEADQgJAgvEuA27A6EJIy6iWUS2jWka1jGoZ1dKBJsB3AUiwyOHTksZAImAdNlpGteBKMJQky1Eto1pGtYxqGdUyqoWMDi8AZHZYA554G4wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/dk.png
// module id = oTXU
// module chunks = 0